// src/hooks/useScrollTop.js
import { useState, useEffect } from "react";

export const useScrollTop = (ref) => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const el = ref?.current;
    if (!el) return;
    const handler = () => {
      const pct = el.scrollTop / (el.scrollHeight - el.clientHeight) * 100;
      setShowScrollTop(pct > 10);
    };
    el.addEventListener("scroll", handler);
    return () => el.removeEventListener("scroll", handler);
  }, []);

  return { showScrollTop };
};